<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            default: false,
        },
        forceOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: this.defaultOpen,
        };
    },
    computed: {
        effectiveOpen() {
            return this.forceOpen || this.isOpen;
        },
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
            console.debug('[SidebarSection] toggled:', this.title, this.isOpen);
        },
    },
};
</script>

<template>
    <div class="sidebar-section">
        <div class="sidebar-section__header" @click="toggle">
            <span
                class="sidebar-section__arrow"
                :class="{ 'sidebar-section__arrow--open': effectiveOpen }"
            >▶</span>
            <span class="sidebar-section__title">{{ title }}</span>
        </div>
        <div v-show="effectiveOpen" class="sidebar-section__body">
            <slot></slot>
        </div>
    </div>
</template>
